import { Controller } from "@hotwired/stimulus";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import channelService from "../../../services/ChannelService";
import httpService from "../../../services/HttpService";
import { storage } from "../../../storageconstants";
import { debugError, debugLog, syncCheckoutOverview } from "../../../utils";

export default class FastTrackOtpPayController extends Controller {
  static values = {
    code:          String,
    session:       String,
    address:       String,
    permitid:      Number,
    tokensymbol:   String,
    challenge:     String,
    typeddata:     String,
    networkName:   String,
    amountDisplay: String,
    channelid:     String,
  }

  initialize() {
    this.attestation = null;
    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
  }

  connect() {
    this.hideLoadingScreen();
    this.challenge = JSON.parse(this.challengeValue);
    this.typedData = JSON.parse(this.typeddataValue);
    syncCheckoutOverview({
      networkName:   this.networkNameValue,
      amountDisplay: this.amountDisplayValue,
    });

    // Pre-subscribe to the Pusher channel at controller-mount time so the
    // first progress event published after /payment/ returns is not missed.
    if (this.channelidValue) {
      channelService.connect(this.channelidValue);
    }
  }

  async pay() {
    this.showLoadingScreen("Verifying payment...");
    try {
      if (!this.challenge) throw new Error("No payment challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      debugLog("Starting WebAuthn signing for fast-track payment challenge");

      const webauthn = new WebAuthnSigner({
        relyingParty: {
          id:   this.domain.domain,
          name: this.domain.company,
        },
      });
      this.attestation = await webauthn.sign(this.challenge);

      this.showLoadingScreen("Payment in progress...");
      await this.submitPayment();
    } catch (error) {
      this.hideLoadingScreen();
      debugError("Error during fast-track payment WebAuthn signing:", error);
    }
  }

  async submitPayment() {
    const data = this.typedData;
    data.session             = this.sessionValue;
    data.address             = this.addressValue;
    data.challengeIdentifier = this.challenge.challengeIdentifier;
    data.firstFactor         = this.attestation;
    data.permitId            = this.permitidValue;
    data.tokenSymbol         = this.tokensymbolValue;

    debugLog("/payment/ endpoint data:", data);

    try {
      const res = await httpService.post(`/payment/`, data);

      switch (res.type) {
        case "channel":
          channelService.connect(res.data);
          break;
        case "html":
          Turbo.renderStreamMessage(res.data);
          if (res.channel) channelService.connect(res.channel);
          break;
        case "redirect":
          Turbo.visit(res.data);
          break;
      }
    } catch (error) {
      this.hideLoadingScreen();
      debugError("Error submitting fast-track payment:", error.message);
    }
  }

  showLoadingScreen(message) {
    this.dispatch("showLoadingScreen", { detail: { text: message || "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
